import { QueryClientConfig } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

const shouldRetry = (failureCount: number, error: Error) => {
  const status = isAxiosError(error) ? Number(error.response?.status ?? 0) : 0;
  return status >= 400 && status < 500 ? false : failureCount < 3;
};

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      refetchOnWindowFocus: import.meta.env.DEV,
      retry: shouldRetry,
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
};
